export const drawerSx = {
    width: 300,
    '& .MuiDrawer-root': {
        position: 'absolute',
    },
    '& .MuiPaper-root': {
        position: 'absolute',
    },
    '& .MuiDrawer-paper': {
        width: 300,
    },
}

export const leftDrawerTabs = [
    { label: 'Data', key: 'data' },
    { label: 'Filters', key: 'filters' },
]

export const rightDrawerTabs = [
    { label: 'Properties', key: 'properties' },
    { label: 'Style', key: 'style' },
]
